import { useState } from 'react'

function setSessionStorage(key: string, value: any) {
  try {
    window.sessionStorage.setItem(key, JSON.stringify(value))
  } catch (e) {
    console.log(e)
  }
}

function getSessionStorage(key: string, initialValue: any) {
  try {
    const value = window.sessionStorage.getItem(key)
    return value ? JSON.parse(value) : initialValue
  } catch (e) {
    return initialValue
  }
}

export default function useSessionStorage(key: string, initialData: any) {
  const [data, setTempData] = useState(() =>
    getSessionStorage(key, initialData),
  )

  const setData = (val: object | ((prev: object) => object)) => {
    if (typeof val === 'function') {
      setTempData((prev: object) => {
        const next = val(prev)
        setSessionStorage(key, next)
        return next
      })
    } else {
      setTempData(val)
      setSessionStorage(key, val)
    }
  }

  return [data, setData]
}
